module.exports = __webpack_public_path__ + "img/mong_ha_fort.82d026eb.jpg";